<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <!-- <router-link to="#" class="route"
      >Next Sample<v-icon>mdi-chevron-right</v-icon></router-link
    > -->
    <v-container fluid>
      <div class="page-title">
        <div class="box mt-2 mb-5">
          <h2>{{ $t("genoPerformance.performanceOfGenoType") }}</h2>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          :to="{
            name: 'GenoTypeEdit',
            params: { id: geno.GTPerformanceNumber },
          }"
        >
          {{ $t("genoPerformance.editAGenoType") }}
        </v-btn>
      </div>
      <div>
        <v-card elevation="0" class="px-5">
          <v-row class="ml-2">
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.breedName") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.breedName ? geno.breedName : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>

            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.chromosome") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.chromosome ? geno.chromosome : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.sequenceChange") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.sequenceChange
                            ? geno.sequenceChange
                            : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.inheritance") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.inheritance ? geno.inheritance : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.diseaseName") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.diseaseName ? geno.diseaseName : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.referenceSequence") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.referenceSequence
                            ? geno.referenceSequence
                            : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col :cols="checkBreakPoints ? 2 : 1"></v-col>
            <v-col :cols="checkBreakPoints ? 4 : 3" class="border-bottom">
              <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
              <v-list dense class="">
                <v-list-item class="mb-n12">
                  <v-list-item-content>
                    <h5>{{ $t("genoPerformance.pubmedReference") }}</h5>
                    <v-list-item-title class="text-h2 ml-n3">
                      <v-text-field
                        :value="
                          geno.pubmedReference
                            ? geno.pubmedReference
                            : 'Not Specified'
                        "
                        readonly
                        flat
                        solo
                        class="font-weight-bold"
                      ></v-text-field>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12"></v-col>
            <v-col cols="12"></v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
// import {mapGetters} from "vuex";
import Breadcrumb from "@/components/core/Breadcrumb";
import GenoService from "@/_services/GenoService";
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  data() {
    return {
      tab: null,
      id: "",
      geno: {},
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "GenoTypeList",
          link: true,
          exact: true,
          disabled: false,
          to: { name: "GenoList" },
        },
        {
          text: "GenotypeDetails",
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
    };
  },
  async mounted() {
    await this.getItem();
  },
  methods: {
    getItem() {
      this.startLoading();
      GenoService.getGeno(this.$route.params.id)
        .then((response) => {
          console.log("res", response);
          this.geno = response.genotypePerformance;
          this.stopLoading();
          // console.log(this.animal);
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
  },
  mixins: [loadingMixin],
};
</script>
<style>
.c-right {
  padding: 0px 0px 50px !important;
}
.border-top {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: gray;
}
.border-right {
  border-right: 1px solid;
  border-color: gray;
}
.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 0px 15px;
}
/* .page-title .h2{
    display: block;
} */
/* .page-title .box .h2{
    font-weight: lighter;
} */
.route {
  text-decoration: none !important;
  position: absolute;
  top: 15px;
  right: 10px;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul {
  margin: 0px;
  padding: 0px;
}
h5 {
  color: grey;
}
.section-boxes1 {
  border-bottom: 1px solid #ccc;
  padding: 15px 15px;
}
.section-boxes1 .boxes-data {
  display: flex;
  justify-content: space-between;
}
.section-boxes1 .box-inline-tab {
  display: flex;
  align-items: center;
}
.section-boxes1 .circle-img {
  background: #ccc;
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.section-boxes1 .box-deatils-part {
  margin-left: 14px;
}
.section-boxes1 .box-deatils-part h2 {
  font-size: 15px;
}
.section-boxes1 .box-deatils-part p {
  font-size: 29px;
  margin-top: 1px;
}
.three-dot {
  margin-bottom: 9px;
}
/* .flex-container {
  display: flex;
  flex-direction: row;
}
.flex-container > div {
  background-color: #f1f1f1;
  width: 100px;
  text-align: center;
  line-height: 75px;
  font-size: 30px;
} */
</style>